{
  "id": "campaign-079",
  "name": "Neglected Fairway",
  "seed": "campaign:79",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,W,,_,",
    ",,h,,,,,,,_,",
    ",,,#,,W,.T_,",
    ",,,,,,,..._T",
    ",,,,h,#..._.",
    "#,,,,,,..._.",
    ",,,,T,ooo._,",
    ",,,,,,oFos_s",
    ",,,,,,ooow_,",
    ",,,,,,,..._.",
    ",,,h,,,..._.",
    ",,,,,,,..._.",
    ",,,,,h,,.._,",
    ",,*T,,,,b,_W",
    ",***,,,,,,_,",
    ",,*T,,,,,,_,",
    ",,,,,,.*.b..",
    ",,,,,,*,...S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 9,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 11
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 11
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 16
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 6
    },
    {
      "kind": "repair",
      "x": 5,
      "y": 7
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 79,
  "biome": "golf",
  "par": {
    "reel": 18684,
    "push": 11329,
    "selfPropelled": 10422,
    "tractor": 5965,
    "zeroTurn": 7071,
    "fairway": 3964
  },
  "routeTries": {
    "par": {
      "reel": 18,
      "push": 24,
      "selfPropelled": 0,
      "tractor": 19,
      "zeroTurn": 13,
      "fairway": 2
    }
  }
}
